export class FailedMessagesProfileReportLoad {
  public static readonly type = '[FailedMessagesProfileReport] Load';
}

export class FailedMessagesProfileReportInitialState {
  public static readonly type = '[FailedMessagesProfileReport] Set Initial State';
}
